import { Policy } from './view';

export { default as PolicyReducer } from './reducer';
export { default as PolicySaga } from './saga';

export default Policy;
